export const PHONE_COUNTRIES = [
  { iso2: "PK", name: "Pakistan", dialCode: "+92" },
  { iso2: "GB", name: "United Kingdom", dialCode: "+44" },
  { iso2: "US", name: "United States", dialCode: "+1" },
  { iso2: "IN", name: "India", dialCode: "+91" },
  { iso2: "AE", name: "United Arab Emirates", dialCode: "+971" },
  { iso2: "SA", name: "Saudi Arabia", dialCode: "+966" },
  { iso2: "BD", name: "Bangladesh", dialCode: "+880" },
  { iso2: "TR", name: "Turkey", dialCode: "+90" },
  { iso2: "FR", name: "France", dialCode: "+33" },
  { iso2: "DE", name: "Germany", dialCode: "+49" },
  { iso2: "IT", name: "Italy", dialCode: "+39" },
  { iso2: "ES", name: "Spain", dialCode: "+34" },
  { iso2: "NL", name: "Netherlands", dialCode: "+31" },
  { iso2: "IE", name: "Ireland", dialCode: "+353" },
  { iso2: "CA", name: "Canada", dialCode: "+1" },
  { iso2: "AU", name: "Australia", dialCode: "+61" },
  { iso2: "NZ", name: "New Zealand", dialCode: "+64" },
  { iso2: "QA", name: "Qatar", dialCode: "+974" },
  { iso2: "KW", name: "Kuwait", dialCode: "+965" },
  { iso2: "OM", name: "Oman", dialCode: "+968" },
  { iso2: "BH", name: "Bahrain", dialCode: "+973" },
  { iso2: "EG", name: "Egypt", dialCode: "+20" },
  { iso2: "MA", name: "Morocco", dialCode: "+212" },
  { iso2: "NG", name: "Nigeria", dialCode: "+234" },
  { iso2: "KE", name: "Kenya", dialCode: "+254" },
  { iso2: "UG", name: "Uganda", dialCode: "+256" },
  { iso2: "ZA", name: "South Africa", dialCode: "+27" },
  { iso2: "CN", name: "China", dialCode: "+86" },
  { iso2: "JP", name: "Japan", dialCode: "+81" },
  { iso2: "MY", name: "Malaysia", dialCode: "+60" },
  { iso2: "SG", name: "Singapore", dialCode: "+65" },
  { iso2: "PH", name: "Philippines", dialCode: "+63" },
  { iso2: "ID", name: "Indonesia", dialCode: "+62" },
  { iso2: "TH", name: "Thailand", dialCode: "+66" },
  { iso2: "PL", name: "Poland", dialCode: "+48" },
  { iso2: "RO", name: "Romania", dialCode: "+40" },
  { iso2: "PT", name: "Portugal", dialCode: "+351" },
  { iso2: "GR", name: "Greece", dialCode: "+30" },
  { iso2: "SE", name: "Sweden", dialCode: "+46" },
  { iso2: "NO", name: "Norway", dialCode: "+47" },
  { iso2: "DK", name: "Denmark", dialCode: "+45" },
  { iso2: "CH", name: "Switzerland", dialCode: "+41" },
  { iso2: "BE", name: "Belgium", dialCode: "+32" },
  { iso2: "AT", name: "Austria", dialCode: "+43" },
  { iso2: "CY", name: "Cyprus", dialCode: "+357" },
  { iso2: "LK", name: "Sri Lanka", dialCode: "+94" },
  { iso2: "AF", name: "Afghanistan", dialCode: "+93" },
];

export const DEFAULT_PHONE_COUNTRY_ISO2 = "PK";

export const countryIsoToFlag = (iso2) => {
  if (!iso2 || iso2.length !== 2) return "🌐";
  return iso2
    .toUpperCase()
    .replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt(0)));
};

export const getPhoneCountryByIso2 = (iso2) =>
  PHONE_COUNTRIES.find((country) => country.iso2 === iso2) ||
  PHONE_COUNTRIES.find((country) => country.iso2 === DEFAULT_PHONE_COUNTRY_ISO2);

export const parsePhoneNumber = (fullPhone, defaultIso2 = DEFAULT_PHONE_COUNTRY_ISO2) => {
  const defaultCountry = getPhoneCountryByIso2(defaultIso2);
  if (!fullPhone) {
    return { iso2: defaultCountry.iso2, dialCode: defaultCountry.dialCode, local: "" };
  }

  const digits = fullPhone.replace(/\D/g, "");
  if (!digits) {
    return { iso2: defaultCountry.iso2, dialCode: defaultCountry.dialCode, local: "" };
  }

  const sorted = [...PHONE_COUNTRIES].sort(
    (a, b) => b.dialCode.replace(/\D/g, "").length - a.dialCode.replace(/\D/g, "").length
  );

  for (const country of sorted) {
    const codeDigits = country.dialCode.replace(/\D/g, "");
    if (digits.startsWith(codeDigits)) {
      return {
        iso2: country.iso2,
        dialCode: country.dialCode,
        local: digits.slice(codeDigits.length),
      };
    }
  }

  return { iso2: defaultCountry.iso2, dialCode: defaultCountry.dialCode, local: digits };
};

export const buildFullPhoneNumber = (dialCode, localNumber) => {
  const localDigits = (localNumber || "").replace(/\D/g, "");
  if (!localDigits) return "";
  return `${dialCode}${localDigits}`;
};
